// src/pages/Cases/Cases.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { casesAPI } from '../../api/cases.js';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs';
import { Loader } from '../../components/ui/Loader/Loader.jsx';
import { Button } from '../../components/ui/Button/Button.jsx';

export const Cases = () => {
  const [cases, setCases] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    loadCases();
  }, [filter]);

  const loadCases = async () => {
    setIsLoading(true);
    try {
      const params = filter !== 'all' ? { category: filter } : {};
      const response = await casesAPI.getAll(params);
      setCases(response.data.data || []);
    } catch (error) {
      console.error('Error loading cases:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const categories = [
    { value: 'all', label: 'Все' },
    { value: 'digital', label: 'Цифровые' },
    { value: 'print', label: 'Печать' },
    { value: 'video', label: 'Видео' },
    { value: 'social', label: 'Соцсети' },
    { value: 'outdoor', label: 'Наружка' },
  ];

  const breadcrumbs = [{ label: 'Кейсы', path: '/cases' }];

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />

        <h1 style={{
          fontSize: '32px',
          fontWeight: 700,
          color: 'rgb(var(--c-text))',
          marginTop: '24px',
          marginBottom: '8px',
        }}>
          Наши кейсы
        </h1>
        <p style={{
          fontSize: '16px',
          fontWeight: 300,
          color: 'rgb(var(--c-text-secondary))',
          marginBottom: '32px',
        }}>
          Реальные проекты и достижения, которые доказывают эффективность нашего подхода
        </p>

        {/* Фильтры */}
        <div style={{
          display: 'flex',
          gap: '8px',
          marginBottom: '32px',
          flexWrap: 'wrap',
        }}>
          {categories.map((cat) => (
            <button
              key={cat.value}
              onClick={() => setFilter(cat.value)}
              style={{
                padding: '8px 20px',
                borderRadius: '100px',
                border: filter === cat.value ? '1px solid rgb(var(--c-accent))' : '1px solid rgb(var(--c-border))',
                backgroundColor: filter === cat.value ? '#205CA0' : 'transparent',
                color: filter === cat.value ? '#FAFAFA' : '#1A1A1A',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500,
                transition: 'all 0.2s',
              }}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {isLoading ? (
          <Loader text="Загрузка кейсов..." />
        ) : cases.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 0',
            color: 'rgb(var(--c-text-secondary))',
          }}>
            <p>Кейсов не найдено</p>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '24px',
          }}>
            {cases.map((caseItem) => (
              <Link
                key={caseItem.id}
                to={`/cases/${caseItem.id}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div style={{
                  backgroundColor: 'rgb(var(--c-surface))',
                  border: '1px solid rgb(var(--c-border))',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  transition: 'box-shadow 0.2s, transform 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.08)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
                >
                  <div style={{
                    backgroundColor: 'rgb(var(--c-surface-2))',
                    height: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'rgb(var(--c-text-secondary))',
                    fontSize: '12px',
                  }}>
                    {caseItem.cover_image ? 'Изображение' : 'Нет фото'}
                  </div>
                  <div style={{ padding: '20px' }}>
                    <div style={{
                      fontSize: '12px',
                      fontWeight: 500,
                      color: 'rgb(var(--c-accent))',
                      textTransform: 'uppercase',
                      letterSpacing: '0.02em',
                    }}>
                      {caseItem.category}
                    </div>
                    <h3 style={{
                      fontSize: '20px',
                      fontWeight: 600,
                      color: 'rgb(var(--c-text))',
                      marginTop: '8px',
                    }}>
                      {caseItem.title}
                    </h3>
                    <p style={{
                      fontSize: '14px',
                      fontWeight: 300,
                      color: 'rgb(var(--c-text-secondary))',
                      marginTop: '8px',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}>
                      {caseItem.description}
                    </p>
                    <div style={{
                      marginTop: '16px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                      <span style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgb(var(--c-text))',
                      }}>
                        {caseItem.client}
                      </span>
                      <span style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgb(var(--c-accent))',
                      }}>
                        Подробнее →
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};